import React, { useState } from 'react';
import { Box, Container, Typography, Tabs, Tab } from '@mui/material';
import { HiChartBar, HiClipboardList, HiSearch } from 'react-icons/hi';
import { useOrganization } from '@/contexts/OrganizationContext';
import { useHealthSummary } from '@/api/hooks/useActivityLog';
import HealthSummaryCards from './components/HealthSummaryCards';
import ActivityFeed from './components/ActivityFeed';
import QuickQueryBar from './components/QuickQueryBar';
import LoadingSpinner from '@/components/LoadingSpinner';

const TAB_CONFIG = [
  { label: 'Resumen de Salud', icon: <HiChartBar size={20} /> },
  { label: 'Actividad', icon: <HiClipboardList size={20} /> },
  { label: 'Consultas', icon: <HiSearch size={20} /> },
];

const ActivityLogPage: React.FC = () => {
  const [activeTab, setActiveTab] = useState(0);
  const { selectedOrganization } = useOrganization();
  const { data: healthSummary, isLoading: healthLoading } = useHealthSummary();

  if (!selectedOrganization) {
    return (
      <Container maxWidth="xl" sx={{ py: 4 }}>
        <Typography variant="h6" color="text.secondary">
          Selecciona una organización para ver el registro de actividad.
        </Typography>
      </Container>
    );
  }

  return (
    <Container maxWidth="xl" sx={{ py: 3 }}>
      <Box sx={{ mb: 3 }}>
        <Typography variant="h4" fontWeight={700} gutterBottom>
          Registro de Actividad
        </Typography>
        <Typography variant="body1" color="text.secondary">
          Observabilidad para {selectedOrganization.name}
        </Typography>
      </Box>

      <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 3 }}>
        <Tabs
          value={activeTab}
          onChange={(_, v) => setActiveTab(v)}
          variant="fullWidth"
        >
          {TAB_CONFIG.map((tab, i) => (
            <Tab
              key={i}
              icon={tab.icon}
              iconPosition="start"
              label={tab.label}
            />
          ))}
        </Tabs>
      </Box>

      {activeTab === 0 && (
        healthLoading ? <LoadingSpinner /> : <HealthSummaryCards summary={healthSummary ?? null} />
      )}
      {activeTab === 1 && <ActivityFeed />}
      {activeTab === 2 && <QuickQueryBar />}
    </Container>
  );
};

export default ActivityLogPage;
